import incidentHighRiskConstants from 'constants/incidentHighRisk'

const incidentHighRiskSteps = (isDpo) => {
  const steps = [
    incidentHighRiskConstants.LARGE_SCALE_ENUM,
    incidentHighRiskConstants.SPECIFIC_CRITERIA_ENUM,
  ]

  if (isDpo) {
    steps.splice(
      2,
      0,
      incidentHighRiskConstants.SIGNIFICANTLY_AFFECT_ENUM,
      incidentHighRiskConstants.IMPACT_ENUM,
    )
  }

  return steps
}

export default incidentHighRiskSteps
